export const formatNumber = (number: number, decimals = 2): string => {
  const parts = number.toFixed(decimals).split('.')

  if (parts[0]) {
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }

  return parts.join('.')
}
